/* ClampedBody: about 15 lines, then a clamp. The fade masks the text itself, so it matches the
   bubble's ground wherever it sits; a painted overlay showed as a band over the last line. */
.clamp {
  max-height: 21.75em;
  overflow: hidden;
}

.clamp[data-overflowing] {
  -webkit-mask-image: linear-gradient(to bottom, black calc(100% - 2.6em), transparent);
  mask-image: linear-gradient(to bottom, black calc(100% - 2.6em), transparent);
}

.clamp[data-expanded] {
  max-height: none;
  -webkit-mask-image: none;
  mask-image: none;
}
